import { render } from "./MilkTottle.vue?vue&type=template&id=777563e6"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/MilkTottle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "777563e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('777563e6', __exports__)) {
    api.reload('777563e6', __exports__)
  }
  
  module.hot.accept("./MilkTottle.vue?vue&type=template&id=777563e6", () => {
    api.rerender('777563e6', render)
  })

}


export default __exports__